<template>
  <div class="tab-section">
    <div class="section-heading">{{ heading }}</div>
    <p class="section-desc">{{ description }}</p>
    <b-form-textarea
      :model-value="modelValue"
      rows="4"
      max-rows="10"
      :disabled="submitting"
      :placeholder="placeholder"
      @update:model-value="$emit('update:modelValue', $event)"
    />
    <b-alert v-if="error" :model-value="true" variant="danger" class="mt-2">{{ error }}</b-alert>
    <div v-if="submitting" class="text-muted mt-2">{{ submittingText }}</div>
    <AiTokenUsage />
  </div>
</template>

<script>
  import AiTokenUsage from './AiTokenUsage.vue'

  export default {
    name: 'ViewAiPanel',
    components: { AiTokenUsage },
    props: {
      modelValue: { type: String, default: '' },
      error: { type: String, default: '' },
      submitting: { type: Boolean, default: false },
      submittingText: { type: String, default: 'Updating this view with AI... this can take up to a minute.' },
      heading: { type: String, default: 'Update with AI' },
      description: { type: String, default: 'Describe the change. The AI updates this saved view through the page API.' },
      placeholder: { type: String, default: 'e.g. show name and email, turn on search, and sort by name' }
    },
    emits: ['update:modelValue']
  }
</script>
